<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/log")
          i.fa.fa-file
          span.ml-1 {{ $tc("ui.logs", 2) }}
      b-breadcrumb-item
        router-link(to="/log/actionlog")
          i.fa.fa-history
          span.ml-1 {{ $t("ui.action_log") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.action") }}
                    b-form-select(v-model="actionType" autofocus)
                      option(value="")
                        | {{ $t("ui.all") }}
                      option(v-for="pageInfo in pageList" v-bind:value="pageInfo")
                        | {{ pageInfo }}
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.search_input") }}
                    DebounceInput(required type="text" v-model="inputSearch" :placeholder="$t('message.search_by_id')")
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.action_by") }}
                    DebounceInput(required type="text" v-model="actionBySearch" :placeholder="$t('message.search_by_action_by')")
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.from") }}
                    date-picker(v-model="startDate" :config="locale")
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.to") }}
                    date-picker(v-model="endDate" :config="locale")
                //- div.col-md-2.mb-1
                //-   DateRangePicker(
                //-     v-model="dateRange"
                //-     :locale-data="locale"
                //-     :autoApply="true"
                //-     :showDropdowns="true"
                //-   )
                //-   div(slot="input" slot-scope="picker")
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.ip_address") }}
                    DebounceInput(required type="text" v-model="ipAddressSearch" :placeholder="$t('message.search_by_ip_address')")
                div.col-md-3.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.sort") }}
                    b-form-select(v-model="sortKey")
                      option(value="dateTime") {{ $t("ui.date_time") }}
                      option(value="actionBy") {{ $t("ui.action_by") }}
                      option(value="action") {{ $t("ui.action") }}
                    b-form-select(v-model="sortType")
                      option(value="asc") {{ $t("ui.ascending") }}
                      option(value="desc") {{ $t("ui.descending") }}
                div.col-md-1.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getActionLog(true)"
                    variant="success"
                    size="sm"
                    )
        div.card-body
          div.row
            div.col-md-10
              b-pagination.float-left(
                size="sm"
                hide-ellipsis
                :total-rows="actionLogTotalRow"
                :per-page="getPageSize"
                v-model="currentActionLogPage"
                @input="changedPage($event)").mb-1
            div.col-md-2
              b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize")
                b-input(:value="actionLogTotalRow" readonly)
          div.row.clusterize
            div.col-md-12
              .clusterize-scroll
                table.tablex(style="width: 100%;" v-columns-resizable)
                  thead
                    tr
                      th(width=50)
                        span #
                      th(width=80 @click="sortOrder('action')")
                        span {{ $t('ui.action') }}
                        i(:class="changeSortKey('action')")
                      th(width=150 @click="sortOrder('dateTime')")
                        span {{ $t("ui.date_time") }}
                        i(:class="changeSortKey('dateTime')")
                      th(width=60)
                        span {{ $t("ui.status") }}
                      th(width=150)
                        span {{ $t("ui.status_desc") }}
                      th(width=100)
                        span {{ $t("ui.ip_address") }}
                      th(width=120)
                        span {{ $t("ui.domain_name") }}
                      th
                        span {{ $t("ui.browser_agent") }}
                      th(width=100 @click="sortOrder('actionBy')")
                        span {{ $t("ui.action_by") }}
                        i(:class="changeSortKey('actionBy')")
                      th(width=100)
                        span {{ $t("ui.target_id") }}
                      th(width=150)
                        span {{ $t("ui.target_action") }}
                      th.text-center(width=80)
                        span {{ $t("ui.details") }}
                  tbody.clusterize-content
                    tr(v-if="actionLogList.length == 0")
                      td(colspan="12").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in actionLogList")
                      td
                        span {{ ((currentActionLogPage - 1) * getPageSize + index + 1) }}
                      td
                        span {{ item.action }}
                      td
                        span {{ getDate(item.dateTime) }}
                      td
                        span {{ item.status }}
                      td
                        span(:title="item.statusDesc") {{ item.statusDesc }}
                      td
                        span(:title="item.ipAddress") {{ item.ipAddress }}
                      td
                        span(:title="item.domainName") {{ item.domainName }}
                      td
                        span(:title="item.browserAgent") {{ item.browserAgent }}
                      td
                        span(:title="item.actionBy") {{ item.actionBy }}
                      td
                        span(:title="item.targetId") {{ item.targetId }}
                      td
                        span(:title="item.targetAction") {{ item.targetAction }}
                      td.actions
                        span(v-if="item.details")
                          a.fa.fa-eye.text-primary(href="#" @click="onView(item)" :title="$t('ui.view')")

    actionloginfo(ref="actionLogInfo" @failed="handleFailed" :info="info")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css";
import actionloginfo from "@/components/log/actionLogInfo.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    actionloginfo
  },
  data: () => ({
    loading: false,
    actionType: "",
    actionLogList: [],
    pageList: config.actionLogAction,
    info: null,
    currentActionLogPage: 1,
    actionLogTotalRow: 0,
    actionBySearch: "",
    ipAddressSearch: "",
    sortKey: "dateTime",
    sortType: "asc",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    startDate: null,
    endDate: null,
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    inputSearch: ""
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    today() {
      return this.$moment(new Date).format('YYYY-MM-DD');
    },
    yesterday() {
      return this.$moment(new Date).add(-1, 'days').format('YYYY-MM-DD');
    }
  },
  mounted: function() {
    this.startDate = this.yesterday;
    this.endDate = this.today;
  },
  methods: {
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getActionLog(true);
    },
    changeSortKey(key, type) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    getDate(dateTime) {
      let convertDateFormat = this.$moment(dateTime).format("YYYY-MM-DD HH:mm:ss");
      return convertDateFormat;
    },
    onView: function(item) {
      this.info = item;
      this.$refs.actionLogInfo.$refs.actionLogInfoModal.show();
    },
    getActionLog: function(isSearch) {
      let url = config.actionLogUrl();

      // reset current page to 1 when "Search" button is clicked..
      if (isSearch) this.currentActionLogPage = 1;

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.actionlog,
        from_date: this.$moment(this.startDate).format("YYYY-MM-DD"),
        to_date: this.$moment(this.endDate).add(1, 'days').format("YYYY-MM-DD"),
        search_input: this.inputSearch,
        action: this.actionType,
        actionBy: this.actionBySearch,
        ipAddress: this.ipAddressSearch,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentActionLogPage,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.actionLogList = response.data.data;
                this.actionLogTotalRow = this.actionLogList.length > 0 ? response.data.totalrow : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentActionLogPage = 1;
      this.getActionLog();
    },
    changedPage: function(pageNo) {
      this.currentActionLogPage = pageNo;
      this.getActionLog();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>